module.exports = __webpack_public_path__ + "img/thumb_Space, Lost to Time.c12ca8da.jpg";